import { SHOW_ALERT, HIDE_ALERT } from '../actions/alert'

/**
 * @todo Maybe we should stack modals in an array, so we can have multiple ones.
 */
const state = {
  alertActive: false,
  alertLevel: 'info',
  alertTitle: '',
  alertSubtitle: '',
  alertIsHtml: false
}

const getters = {
  alertActive: state => !!state.alertActive,
  alertLevel: state => state.alertLevel,
  alertTitle: state => state.alertTitle,
  alertSubtitle: state => state.alertSubtitle,
  alertIsHtml: state => !!state.alertIsHtml
}

const actions = {
  [SHOW_ALERT]: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      if (state.alertActive) {
        commit(HIDE_ALERT)

        setTimeout(function () {
          commit(SHOW_ALERT, payload)
        }, 1000)
      } else {
        commit(SHOW_ALERT, payload)
      }
    })
  },

  [HIDE_ALERT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(HIDE_ALERT)
    })
  }
}

const mutations = {
  [SHOW_ALERT]: (state, payload) => {
    state.alertLevel = payload.level
    state.alertTitle = payload.title
    state.alertSubtitle = payload.subtitle || ''
    state.alertActive = true
    state.alertIsHtml = payload.isHtml || false
  },
  [HIDE_ALERT]: (state) => {
    state.alertActive = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/alert.js